<db-dialog-wrapper [dialog]="this" [width]="'450px'" [canClose]="!loading" [hasCloseButton]="!loading"  [canCloseByBackdrop]="!loading">
  <div class="db-import-template db-generate-password-sm">
    <div class="db-confirm-dialog__header">{{(generatingFor === 'sftp' ? 'text_hostingDatabaseSftp' : 'text_generateMySqlPassword') | dbText }}</div>
    <div class="db-confirm-dialog__message mt15">
      <span [innerHTML]="'text_confirmGenerateSftpPassword' | dbText"></span>
    </div>
    <div class="db-confirm-dialog__buttons">
      <a class="ds-btn"  [ngClass]="{'db-button_disabled': loading}" (click)="cancel()"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="ds-btn-black sl-sftp-confirm-generate-password"  [ngClass]="{'db-button_disabled': loading}"
         (click)="generatingFor === 'sftp' ? generateSftpPassword() : generateMySqlPassword()">
        <span *ngIf="!loading" >{{'text_generate' | dbText | lowerCaseSpecificWords}}</span>
        <db-loading-circular-spinner class="sl-sftp-generate-password-loader" *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
